<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="BMH">CONTENTS</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyright_notice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc-bot"><a href="#/xhtml/epigraph#epi">Epigraph</a></p>
<p class="toc"><a href="#/xhtml/prologue#pro">Prologue</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">The Last Option</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">Blossomwood</a></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">A Night Out</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">The Gift of Perfect Pitch</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">In Another Life</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">A Moment in Time</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Falcons</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Flight Dreams</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Magnet and Steel</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Heaven and Earth</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Tomorrowland</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Dark Chocolate</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Table for Two</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Broken Glass</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Paper Clip</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Dawn</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Character</span></p>
<p class="toc"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Mirror, Mirror</span></p>
<p class="toc"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Insurance</span></p>
<p class="toc"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Croatian Wood</span></p>
<p class="toc"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Turning Points</span></p>
<p class="toc"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Heart and Soul</span></p>
<p class="toc"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Redemption</span></p>
<p class="toc"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Repairing the World</span></p>
<p class="toc"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Dreams of Heaven</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">Coda</span></p>
<p class="toc"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Also by Jeffrey Stepakoff</span></p>
<p class="toc"><span href="#/xhtml/aboutauthor#abt" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#copy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?09a3430a